module.exports = __webpack_public_path__ + "prod/1.42.2/img/zxkf.45f61c24.svg";